import React from 'react'
// import moment from 'moment'
// import 'moment/locale/fr' 

import { BsFillChatRightQuoteFill } from "react-icons/bs";

import Card from "./Cards"


const Testimonial = ({testimonial}) => {
	return (
		
		<Card className="card">
			<div className="testimonial__client">
				<div className="testimonial__client-avatar">
					<img src={testimonial.avatar} alt="testimonial avatar" style={{borderRadius:"50%"}} />
					<p className="">{testimonial.name}</p>
				</div>
				<div className="testimonial__client-details " style={{fontFamily:"Poppins-Regular", marginRight:"2rem"}}>
				
				  <BsFillChatRightQuoteFill className='testimonial__quote'/>
					<figcaption className="review__user">
					   <div className="review__user-box ">
						 <blockquote className="review__text"> {testimonial.blockquote.substring(0,80)}...</blockquote>
						</div>
					</figcaption>
					
					{/* <h5 ><BsCalendarEvent/> {moment(testimonial.date).format("DD MMMM YYYY")}</h5> */}
				</div>
				<div className="review__rating">{testimonial.rating}</div>
			</div>
			<span className="testimonial_project_title" >{testimonial.projetCat}</span>
		</Card>
	)
}

export default Testimonial